// src/api/landingApi.ts
//
// Landing page demo requests go to Web3Forms, the same inbox every DecisionOpt
// product page uses. Web3Forms access keys are public by design: they only allow
// sending to the inbox they were issued for. Override with REACT_APP_WEB3FORMS_KEY.
//
// This deliberately does not use the shared axios client: that one targets the
// ExPlan backend and attaches auth headers a third-party endpoint must not get.

const WEB3FORMS_URL = 'https://api.web3forms.com/submit';
const WEB3FORMS_KEY = process.env.REACT_APP_WEB3FORMS_KEY || '88d13c74-ed25-43ba-bffd-04720b7b5a6c';

export interface DemoRequestPayload {
  name: string;
  email: string;
  company: string;
  phone?: string;
  message?: string;
  /** Local YYYY-MM-DD, never derived from toISOString(). */
  preferredDate: string;
  /** Human label, e.g. "3:00 PM". Always IST. */
  preferredTime: string;
}

export class DemoRequestError extends Error {
  /** True when the request never reached Web3Forms (offline, blocked, DNS). */
  readonly network: boolean;

  constructor(message: string, network: boolean) {
    super(message);
    this.name = 'DemoRequestError';
    this.network = network;
  }
}

export const landingApi = {
  submitDemoRequest: async (payload: DemoRequestPayload): Promise<void> => {
    let response: Response;
    try {
      response = await fetch(WEB3FORMS_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          subject: `ExPlan demo request: ${payload.preferredDate} at ${payload.preferredTime} IST`,
          from_name: 'ExPlan Landing',
          name: payload.name,
          email: payload.email,
          company: payload.company,
          phone: payload.phone || 'N/A',
          message: payload.message || 'N/A',
          preferred_date: payload.preferredDate,
          preferred_time: `${payload.preferredTime} IST`,
        }),
      });
    } catch {
      throw new DemoRequestError('network', true);
    }

    const data = await response.json().catch(() => null);
    if (!response.ok || !data?.success) {
      throw new DemoRequestError(data?.message || `HTTP ${response.status}`, false);
    }
  },
};

export default landingApi;
